import React from 'react';
import DatePicker, { registerLocale } from 'react-datepicker';
import { ptBR } from 'date-fns/locale';
import 'react-datepicker/dist/react-datepicker.css';

registerLocale('pt-BR', ptBR);

function parseYmd(ymd) {
  if (!ymd || !/^\d{4}-\d{2}-\d{2}$/.test(ymd)) return null;
  const [y, m, d] = ymd.split('-').map((n) => parseInt(n, 10));
  const date = new Date(y, m - 1, d);
  return Number.isNaN(date.getTime()) ? null : date;
}

function toYmd(date) {
  if (!(date instanceof Date) || Number.isNaN(date.getTime())) return '';
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, '0');
  const d = String(date.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
}

/**
 * Campo de data com calendário em português.
 * value/onChange usam string YYYY-MM-DD (compatível com filtros existentes).
 */
export default function DateInputPt({
  value = '',
  onChange,
  className = '',
  placeholder = 'dd/mm/aaaa',
  disabled = false,
  min,
  max,
  title
}) {
  const selected = parseYmd(value);
  const minDate = parseYmd(min);
  const maxDate = parseYmd(max);

  return (
    <DatePicker
      selected={selected}
      onChange={(date) => onChange?.(date ? toYmd(date) : '')}
      locale="pt-BR"
      dateFormat="dd/MM/yyyy"
      placeholderText={placeholder}
      disabled={disabled}
      minDate={minDate || undefined}
      maxDate={maxDate || undefined}
      title={title}
      isClearable
      showMonthDropdown
      showYearDropdown
      dropdownMode="select"
      className={className}
      calendarClassName="datepicker-pt-br"
      wrapperClassName="w-full"
    />
  );
}
